export const GENDER_LIST_ONBOARDING = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'nonBinary', label: 'Non-Binary' },
]

/** Self-service onboarding only: a consumer may decline to state a gender. Clinical report
 *  forms keep the three-value list above. */
export const GENDER_ONBOARDING_OPT_OUT = 'noAnswer'
export const GENDER_LIST_ONBOARDING_WITH_OPT_OUT = [
  ...GENDER_LIST_ONBOARDING,
  { value: GENDER_ONBOARDING_OPT_OUT, label: 'Prefer not to say' },
]

export const RELATIONSHIP_OPTIONS = [
  { value: 'relative', label: 'Relative' },
  { value: 'son', label: 'Son' },
  { value: 'daughter', label: 'Daughter' },
  { value: 'father', label: 'Father' },
  { value: 'mother', label: 'Mother' },
  { value: 'brother', label: 'Brother' },
  { value: 'sister', label: 'Sister' },
  { value: 'grandfather', label: 'Grandfather' },
  { value: 'grandmother', label: 'Grandmother' },
  { value: 'husband', label: 'Husband' },
  { value: 'wife', label: 'Wife' },
  { value: 'guardian', label: 'Guardian' },
  { value: 'friend', label: 'Friend' },
]

export const displayNamesOfEventTypes = {
  '1on1': 'One-on-one',
  interview: 'Interview Session',
  consultation: 'Consultation',
  'therapy-session': 'Therapy Session',
  webinar: 'Webinar',
  screening: 'Screening',
  assessment: 'Assessment',
  'discovery-call': 'Discovery Call',
}
